import { AppointmentTask } from "@/models/appointment-task.model";
import type { ChecklistCategory } from "@/lib/appointment-checklist";

export interface ChecklistProgress {
  completed: number;
  total: number;
  allComplete: boolean;
}

function isNewer(a: AppointmentTask, b: AppointmentTask): boolean {
  if (a.updated_at !== b.updated_at) return a.updated_at > b.updated_at;
  if (a.created_at !== b.created_at) return a.created_at > b.created_at;
  return a.id > b.id;
}

export function buildLatestTaskMap(appointmentTasks: AppointmentTask[]): Map<string, AppointmentTask> {
  const latest = new Map<string, AppointmentTask>();
  for (const at of appointmentTasks) {
    const current = latest.get(at.task);
    if (!current || isNewer(at, current)) {
      latest.set(at.task, at);
    }
  }
  return latest;
}

export function getChecklistProgress(
  serviceTasks: ChecklistCategory[],
  appointmentTasks: AppointmentTask[]
): ChecklistProgress {
  const latest = buildLatestTaskMap(appointmentTasks);
  const allTasks = serviceTasks.flatMap((category) => category.tasks || []);
  const completed = allTasks.filter((task) => !!latest.get(task.id)?.done).length;

  return {
    completed,
    total: allTasks.length,
    allComplete: completed === allTasks.length,
  };
}

export function getChecklistGateError(progress: ChecklistProgress, checklistLoaded: boolean): string | null {
  if (!checklistLoaded) {
    return "The task checklist hasn't loaded yet. Wait a moment or reload the page, then try again.";
  }
  if (!progress.allComplete) {
    return `Complete all service tasks before finishing work (${progress.completed} of ${progress.total} done)`;
  }
  return null;
}
